import React from 'react';
import './OfflinePlayer.scss';
import { withNavigate } from '../../util/withNavigate';
// import { fireAnalytics, getQualityFlag, getMuteFlag } from '../../pages/utils'
// import { setInterval } from 'timers';
// import { ThinkPeaks } from 'styled-icons/fa-brands';

export class OfflinePlayer extends React.Component {

  constructor(props) {
    super(props);

    // this.state = {
    // artwork: props.artwork,
    // showLoader: true,
    // mute: getMuteFlag(),
    // highquality: getQualityFlag(),
    // isCurrent: props.isCurrent,
    // downloadInfo: false,
    // posterImage: true
    // };
    // this.getArtworkUrl = this.getArtworkUrl.bind(this);
    this.getArtworkVideoUrl = this.getArtworkVideoUrl.bind(this);
    this.artworkNumber = 0;
    this.artworks = [];
    this.isUSB = false;
    this.videoRef = React.createRef();
  }

  componentDidMount() {
    this.getUSBInformation();
    setInterval(() => {
      if(this.artworkNumber >= this.artworks.length) {
        this.artworkNumber = 0;
      }
      this.getArtworkVideoUrl(this.artworkNumber);
      // this.artworkNumber = this.artworkNumber + 1;
    }, 300000);
    // this.getArtworkVideoUrl(this.artworkNumber);
    // window.addEventListener('online', this.handleConnectionChangePlayer);
    // window.addEventListener('offline', this.handleConnectionChangePlayer);
  }

  goToPage = (pageLink) => {
    const { navigate } = this.props;
    navigate(pageLink);
  };

  handleConnectionChangePlayer(event) {
    if (event.type == "online") {
      this.goToPage(`/`);
    }
  }

  getUSBInformation() {
    // console.log("Inside Check USB Info");
    const that = this;
    function successCb(cbObject) {
      // console.log("USB Success");
      if (cbObject.usbList.length >= 1) that.isUSB = true;
      that.listDownloadedFiles();
    }

    function failureCb(cbObject) {
      var errorText = cbObject.errorText;
      // console.log("Error Code [" + errorCode + "]: " + errorText);
      that.listDownloadedFiles();
    }

    var storage = new Storage();
    storage.getUSBInfo(successCb, failureCb);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  listDownloadedFiles() {
    // console.log("Inside List Files");
    const that = this;
    var offlineURL = "";
    var successCb = function (cbObject) {
      var files = cbObject.files;
      if (files.length <= 0) {
        if (that.isUSB) {
          that.isUSB = false;
          that.listDownloadedFiles();
        } else {
          that.goToPage("/error");
        }
      }
      for (var i = 0; i < files.length; ++i) {
        var fileInfo = files[i];
        if (that.isUSB) offlineURL = `http://127.0.0.1:9080/external/${window.usbName}/list/me/` + fileInfo.name;
        else offlineURL = "http://127.0.0.1:9080/Blackdove/" + fileInfo.name;
        that.artworks[i] = offlineURL;
      }
      const video = this.videoRef.current;
      video.pause();
      video.src = that.artworks[that.artworkNumber];
      video.load();
      video.play();
      that.artworkNumber = that.artworkNumber + 1;
    };

    var failureCb = function (cbObject) {
      var errorCode = cbObject.errorCode;
      var errorText = cbObject.errorText;
      // console.log(" Error Code [" + errorCode + "]: " + errorText);
    };
    var listOption;
    // List files in the internal memory
    if (!this.isUSB) {
      listOption = {
        path: "file://internal/Blackdove/"
      };
    } else {
      // List files in the mass storage device in USB port 1.
      listOption = {
        path: "file://usb:1/list/me"
      };
    }

    var storage = new Storage();
    storage.listFiles(successCb, failureCb, listOption);
  }

  getArtworkVideoUrl(num) {
    if(this.artworks.length > 0 && num <= this.artworks.length) {
      const video = this.videoRef.current;
      video.pause();
      video.src = this.artworks[this.artworkNumber];
      video.load();
      video.play();
      this.artworkNumber = this.artworkNumber + 1;
    }
  }
  render() {
    // const { artwork } = this.state;
    return (
      <div className="full-screen-carousel-item">
        {/* <div className="full-screen-carousel-item__image" style={!this.props.isCurrent && !this.props.nxtPre ? { backgroundImage: `url(${this.getArtworkUrl(artwork)})` } : { background: `none` }}> */}
        {/* <img className="poster" id="poster" src={this.getArtworkUrl(artwork)} style={this.state.posterImage ? { opacity: '1' } : { opacity: '0' }} /> */}
        {/* {this.state.showLoader && this.state.isCurrent ? <div tabIndex="-1" > <span className="spinner spinner--small loader" ></span></div> : null} */}
        {/* {(this.props.isCurrent) ?  */}
        <video tabIndex="-1" id="video" ref={this.videoRef} autoPlay loop texture="true"></video>
        {/*  : null} */}
        {/* {(this.props.nxtPre || this.props.other) ? <video tabIndex="-1" src={this.getArtworkVideoUrl(artwork)} muted onCanPlay={() => { this.props.loadOthers() }} poster={this.getArtworkUrl(artwork)}></video> : null} */}
        {/* </div> */}
        {/* <div className="downloadInfo" style={!this.state.downloadInfo ? { opacity: '0' } : { opacity: '1' }} >{this.downloadInfoText}</div> */}
      </div>
    )
  }
};

export default withNavigate(OfflinePlayer)